module.exports = __webpack_public_path__ + "static/img/confirm2.119f57d.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/confirm2.png
// module id = 899
// module chunks = 1